import { addNotification } from "./helpers/notifications";

const FormValidator = {
  init: () => {
    document
      .querySelector("body")
      .addEventListener("submit", FormValidator.onFormSubmit);
  },

  onFormSubmit: (e) => {
    if (
      !(
        e.target.tagName.toLowerCase() === "form" &&
        (e.target.getAttribute("name") === "userdetailsform" ||
          e.target.getAttribute("name") === "registerform")
      )
    ) {
      return;
    }

    const form = e.target;
    form.classList.add("form--is-loading");

    const data = Array.from(new FormData(form).entries()).reduce(
      (data, [key, value]) => {
        return {
          ...data,
          [key]: value,
        };
      },
      {}
    );

    // Ensure data.first_name and data.last_name are set and does not contain numbers.
    if (
      !data.first_name ||
      !data.last_name ||
      !data.first_name.match(/^[a-zA-ZÀ-ÖØ-öø-ſ']+([- ]?[a-zA-ZÀ-ÖØ-öø-ſ']+)*$/i) ||
      !data.last_name.match(/^[a-zA-ZÀ-ÖØ-öø-ſ']+([- ]?[a-zA-ZÀ-ÖØ-öø-ſ']+)*$/i)
    ) {
      addNotification(
        "Var god ange ett giltligt namn och efternamn.\nNamn och efternamn kan ej lämnas tomma och får endast innehålla bokstäver samt vissa tillåtna speciella karaktärer.",
        "error"
      );
      e.preventDefault();
    }

    form.classList.remove("form--is-loading");
  },
};

export default FormValidator;
